import { defineStore } from "pinia"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: {
      loggedIn: false,
      data: null
    }
  }),

  actions: {
    setUserFromFirebase(user) {
      this.user.loggedIn = !!user
      if (user) {
        this.user.data = {
          id: user.uid,
          displayName: user.displayName,
          email: user.email
        }
      } else {
        this.user.data = null
      }
    }
  },

  getters: {
    currentUser(state) {
      return state.user
    },
    loggedIn(state) {
      return state.user.loggedIn
    }
  }
})

